import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { DeleteModal } from '../../../../component/modal/deleteModal';
import delete_icon from '../../../../assets/delete_icon.svg';
import { ILifeStyleService } from '../../../../store/lifeStyle/interface';

type ICategoryList = {
  services?: ILifeStyleService;
};

export const ServiceListCard: FC<ICategoryList> = ({ services }) => {
  const [deleteServicesModal, setDeleteServicesModal] = useState(false);

  return (
    <Card>
      {deleteServicesModal && (
        <DeleteModal
          deleteBtnClick={() => {}}
          deleteText="Are you sure you want to delete this Hotel, this action can’t be undone?"
          deleteTitle="Delete Category"
          cancelBtnClick={() => setDeleteServicesModal(false)}
        />
      )}
      <StoreImage src={services?.file.url} />
      <DeleteBtn onClick={() => {}}>
        <Icon src={delete_icon} />
      </DeleteBtn>
      <StoreDetails>
        <StoreHeader>
          <StoreName>{services?.title}</StoreName>
        </StoreHeader>
      </StoreDetails>
    </Card>
  );
};

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  position: relative;
  padding: 8px;
  width: calc(30.33% - 16px);
  max-height: 498px;
  margin: 0px 10px;
  margin-bottom: 48px;
  @media (max-width: 1000px) {
    width: calc(45% - 16px);
    margin: 0px 15px;
    margin-bottom: 48px;
  }
  @media (max-width: 730px) {
    width: 100%;
    margin: 0;
    margin-bottom: 48px;
  }
`;

const StoreImage = styled.img`
  border-radius: 16px;
  width: 100%;
  height: 200px;
  object-fit: cover;
  background-color: #c4c4c4;
`;
const DeleteBtn = styled.button`
  position: absolute;
  right: 24px;
  top: 16px;
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
`;
const Icon = styled.img`
  max-height: 48px;
  max-width: 48px;
`;

const StoreDetails = styled.div`
  padding: 23px 16px 0px 16px;
`;

const StoreHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const StoreName = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  text-transform: capitalize;
`;
